import React, { useEffect, useMemo, useRef, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { GOOGLE_MAPS_API_KEY } from 'src/utils/keys';
import { getCoordinatesFromWKT, getStaticMapWithPolygonAndMarkets } from 'src/utils/functions';
import { COLOR_PRIMARY_DARK } from 'src/utils/const';
import {
  COLOR_PRIMARY_2,
  COLOR_PRIMARY_2_600,
  COLOR_PRIMARY_2_700,
  COLOR_PRIMARY_2_800,
  COLOR_SECONDARY_1_600,
  COLOR_SECONDARY_1_700,
  COLOR_SECONDARY_1_800,
} from 'src/utils/colors';
import { Box } from '@mui/material';
import SubmarketTooltip from './SubmarketTooltip';
import { calculateBoundsAll, calculateZoomLevel, getTop3Submarkets } from './helper';
import { formatMarketName } from 'src/utils/functions';
import { Search, Coordinates } from 'src/interfaces/idashboard';

const SubmarketMarker = ({
  text,
  lat,
  lng,
  submarketData,
  handleOnSampleClick,
  isSubmarketAccessAllowed,
  setDashboardLayoutView,
}: {
  text: string;
  lat: number;
  lng: number;
  submarketData: any;
  handleOnSampleClick: (plan: string) => void;
  isSubmarketAccessAllowed: boolean;
  setDashboardLayoutView: (view: string) => void;
}) => (
  <SubmarketTooltip
    content={submarketData.submarketDescription}
    submarketData={submarketData}
    title={text}
    handleOnSampleClick={handleOnSampleClick}
    isSubmarketAccessAllowed={isSubmarketAccessAllowed}
    setDashboardLayoutView={setDashboardLayoutView}
    showCta={true}
  >
    <Box
      style={{
        color: COLOR_PRIMARY_2,
        fontWeight: 'bold',
        position: 'absolute',
        width: '140px',
        height: '30px',
        backgroundColor: 'white',
        borderRadius: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // border: '2px solid red',
        boxShadow: '0 2px 4px #0002',
        transform: 'translate(-50%, -50%)',
        zIndex: 9999999,
      }}
    >
      {text}
    </Box>
  </SubmarketTooltip>
);

interface SubmarketStaticMapProps {
  submarkets: any[];
  handleOnSampleClick: (plan: string) => void;
  isSubmarketAccessAllowed: boolean;
  setDashboardLayoutView: (view: string) => void;
  isMobileView: boolean;
}

const SubmarketStaticMap = ({
  submarkets,
  handleOnSampleClick,
  isSubmarketAccessAllowed,
  setDashboardLayoutView,
  isMobileView,
}: SubmarketStaticMapProps) => {

  const mapContainerRef = useRef<HTMLDivElement>(null);

  const top3Submarkets = useMemo(() => {
    return getTop3Submarkets(submarkets);
  }, [submarkets]);

  useEffect(() => {
    if (top3Submarkets.length) {
      const mapContainer = mapContainerRef.current;
      if (mapContainer) {
        const height = mapContainer.offsetHeight;
        const width = mapContainer.offsetWidth;
        const mapImageUrl = getStaticMapWithPolygonAndMarkets(top3Submarkets, height, width);
        mapContainer.querySelector('img')?.setAttribute('src', mapImageUrl);
      }
    }
  }, [top3Submarkets]);


  return (
    <div
      ref={mapContainerRef}
      style={{
        width: '100%',
        height: isMobileView ? 'auto' : '650px',
        aspectRatio: isMobileView ? '1 / 1' : 'auto',
        borderRadius: '16px',
        overflow: 'hidden',
      }}
    >
      <img
        src=""
        alt="Submarket Static Map"
        // For now the business requirement, don't open the submarkets tab on click of the map
        style={{
          // cursor: 'pointer',
          borderRadius: '16px',
        }}
        // onClick={() => {
        //   setDashboardLayoutView('submarkets');
        // }}
        // onDragStart={e => {
        //   e.preventDefault();
        //   setDashboardLayoutView('submarkets');
        // }}
      />
    </div>
  );
};

export default SubmarketStaticMap;
